/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Short_Notice_TitleInputs */



/**
* | output |
* | --- |
* | "Usage Notice - Guardrails" |
*
* @param {Guardrails_Short_Notice_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_short_notice_title = /** @type {((inputs?: Guardrails_Short_Notice_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Short_Notice_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzungshinweis - Guardrails")
	return /** @type {LocalizedString} */ ("Usage Notice - Guardrails")
});